import { forwardRef, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { useNotification } from "../context/NotificationContext";
import { useNavigateWithLang } from "../utils/navigation";

const NotificationCenter = () => {
  const { notifications, markNotificationAsRead } = useNotification();
  const location = useLocation();
  const notificationRefs = useRef({});

  const navigate = useNavigateWithLang();
  const notificationIDPayload = location.state?.notificationID;

  const handleNotificationClick = async (notification) => {
    if (!notification.read_at) {
      await markNotificationAsRead(notification.id);
    }

    if (notification.link) {
      navigate(notification.link);
    }
  };

  useEffect(() => {
    if (notificationIDPayload && notificationRefs.current[notificationIDPayload]) {
      const el = notificationRefs.current[notificationIDPayload];
      console.log(el);

      el?.scrollIntoView({ behavior: "smooth", block: "center" });
      el?.classList.add("bg-blue-200", "transition-colors");

      // Optionally remove the background after 3s
      const timeout = setTimeout(() => {
        el?.classList.remove("bg-blue-200");
      }, 3000);

      return () => clearTimeout(timeout);
    }
  }, [notificationIDPayload]);

  return (
    <div className="mx-auto w-full max-w-3xl rounded-xl bg-white shadow-lg dark:bg-gray-900">
      <div className="flex items-center justify-between border-b px-4 py-3">
        <h2 className="text-lg font-bold dark:text-white">Notifications</h2>
      </div>

      <div className="max-h-[500px] overflow-y-auto">
        {notifications?.length > 0 ? (
          notifications.map((n) => (
            <NotificationItem
              key={n.id}
              notification={n}
              onClick={() => handleNotificationClick(n)}
              ref={(el) => (notificationRefs.current[n.id] = el)}
            />
          ))
        ) : (
          <div className="p-4 text-center text-sm text-gray-500 dark:text-gray-400">No notifications</div>
        )}
      </div>
    </div>
  );
};

const NotificationItem = forwardRef(({ notification, onClick }, ref) => {
  const { key, message, read_at } = notification;

  return (
    <div
      ref={ref}
      onClick={onClick}
      className={`flex cursor-pointer items-start gap-3 p-3 transition-colors ${
        !read_at ? "bg-blue-50 dark:bg-gray-800" : ""
      } hover:bg-gray-100 dark:hover:bg-gray-800`}
    >
      <div className="h-10 w-10 rounded-full bg-gray-300 text-center text-sm leading-10 dark:bg-gray-700">
        🔔
      </div>
      <div className="flex-1">
        <div className="text-sm font-medium capitalize text-gray-800 dark:text-white">{key}</div>
        <div className="text-xs text-gray-600 dark:text-gray-300">{message}</div>
      </div>
      {!read_at && <span className="mt-1 h-2 w-2 rounded-full bg-blue-500" />}
    </div>
  );
});

export default NotificationCenter;
